import React from 'react';
import { partyColors, MemoImage } from './ApiUtils';

const fontColor = '#5a6a7a', borderColor = '#a4a6aa';

const PartyUI1 = ({ partyItem, partyLogos, stateIndex, isMpMla }) => {

    let { partyId, mlaLeads, mpLeads } = partyItem;
    let partyLogo = partyLogos[partyId];
    const isIndia = stateIndex==0;
    const partyColor = partyColors[partyId];
    let { mla, mp } = isMpMla;

    return (
        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', width: 230, height: 120,
        padding: 20, fontWeight: 'bold', color: fontColor, fontSize: 14, cursor: 'pointer' }}>
            <div style={{ display: 'flex', alignItems: 'center', borderRadius: 54, padding: 16,
            zIndex: 1, border: '2px solid #D5D6DD', backgroundColor: '#fff' }}>
                {MemoImage(partyLogo, partyId)}
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', borderRadius: 5, marginLeft: -10,
            border: '2px solid #D5D6DD', backgroundColor: '#fff', width: 150  }}>
                <div style={{ textAlign: 'center', padding: 8, border: '0px solid #D5D6DD',
                backgroundColor: partyColor, color: '#fff',
                borderBottomWidth: 2, justifyContent: 'center', paddingLeft: 20, paddingRight: 20 }}>
                {partyId}
                </div>
                <div style={{ display: isIndia||(!mla) ? 'none' : 'flex', textAlign: 'center', padding: 8,
                border: '0px solid #D5D6DD', borderBottomWidth: mp ? 2 : 0, justifyContent: 'center',
                paddingLeft: 20, paddingRight: 20 }}>
                MLA - {mlaLeads||0}
                </div>
                <div style={{ display: mp ? 'flex' : 'none', textAlign: 'center', padding: 8,
                justifyContent: 'center', paddingLeft: 20, paddingRight: 20 }}>
                MP - {mpLeads||0}
                </div>
            </div>
        </div>
    );
}

export default PartyUI1;